/**
 * Orvi Script Loader - Simple approach for reliable form handling
 * Disables complex form manager to prevent conflicts
 */

(function () {
  'use strict';

  // Disable the complex form manager to prevent conflicts
  window.OrviFormManager = {
    registerFormHandler: function () { return false; },
    isFormHandled: function () { return false; },
    markFormHandled: function () { return false; },
    removeFormHandler: function () { return false; },
    detectFormType: function () { return null; },
    getFormId: function () { return null; },
    checkElementConflicts: function () { return false; },
    cleanupDuplicateHandlers: function () { return false; },
    getActiveHandlers: function () { return []; }
  };

  // Simple ready state tracking
  window.OrviScriptLoader = {
    isReady: function () { return true; },
    loaded: { simpleHandler: false },
    markLoaded: function (name) { this.loaded[name] = true; }
  };

  // Define legacy sendZohoSubmission function as a no-op to prevent ReferenceError
  // This function was expected by the Shopify theme but all form submissions
  // are now handled by the individual form handler scripts
  if (typeof window.sendZohoSubmission === 'undefined') {
    window.sendZohoSubmission = function (formData, formType) {
      console.log('Legacy sendZohoSubmission called - form submissions are now handled by Orvi form scripts');
      // The form submission is handled by the individual form scripts
      // This function is a no-op fallback
      return Promise.resolve({ success: true, message: 'Form handled by Orvi scripts' });
    };
  }

  console.log('Orvi: Using simple form handler approach');

})();
